import React from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { Main } from './components';

function App() {
  return (
    <>
      <div className="App animate__animated animate__fadeIn">
        <Main />
      </div>
    </>
  );
}

export default App;
